<template>
  <modal-component
    @close="onClose"
    @aceptar="onClose"
    buttonLabel="Cerrar"
    :bodyScroll="isMobile"
    :label="label"
    :show="true"
  >
    <div class="container">
      <p class="titulo">Cómo consultar mi CBU</p>
      <p class="subtitulo">Podés consultar tu CBU de tres maneras:</p>
      <div class="bullets-container">
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">
            <strong>Banca Online</strong><br />
            Una vez que generes tu Usuario y Clave Digital, hacé clic en la
            cuenta sobre la que querés consultar y luego en “Operaciones” hacé
            clic en “Consulta de CBU”.
          </p>
        </span>
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">
            <strong>BBVA Móvil</strong><br />
            Una vez que creés tu Usuario y Clave Digital, seleccioná la cuenta
            que querés consultar y luego en “Operaciones” seleccioná en
            “Consulta de CBU”.
          </p>
        </span>
        <span class="bullet">
          <img
            class="bullet-img"
            src="@/assets/img/1x/li-azul.png"
            alt="Linea azul"
          />
          <p class="bullet-text">
            <strong>Cajero Banelco</strong><br />
            Ingresá tu tarjeta de débito, tu PIN y seleccioná la opción
            “Consultas” y luego “Consulta de CBU”.
          </p>
        </span>
      </div>
    </div>
  </modal-component>
</template>
<script>
import ModalComponent from "@/components/core/ModalComponent";

export default {
  name: "ModalCBU",
  components: {
    ModalComponent
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    resizeHandler() {
      this.windowWidth = window.innerWidth;
    }
  },
  data() {
    return { windowWidth: window.innerWidth };
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  computed: {
    isMobile() {
      return this.windowWidth < 600;
    },
    label() {
      return this.windowWidth < 600 ? "Cómo consultar mi CBU" : "";
    }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: #1973b8;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.titulo {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #121212;
}

.subtitulo {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #121212;
  margin-top: -10px;
  margin-bottom: 35px;
}

.container {
  width: 100%;
  text-align: center;
}

.bullets-container {
  width: 580px;
  text-align: left;
}

.bullet {
  display: block;
  margin-bottom: 30px;
}

.bullet-img {
  display: inline-block;
  margin-right: 10px;
  margin-left: 30px;
  vertical-align: top;
  width: 20px;
}

.bullet-text {
  display: inline-block;
  vertical-align: top;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #121212;
  margin-top: 0px;
  margin-bottom: 0px;
  width: 90%;
}

@media screen and (max-width: 600px) {
  .bullets-container {
    width: 95%;
  }
  .bullet-img {
    margin-left: 5px;
  }
  .titulo {
    display: none;
  }
  .subtitulo {
    margin-top: 0px;
  }
}
</style>
